module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/credit-cards-c37c5ec412fc7194f102f210d2235bcb.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/credit-cards.svg
// module id = W2/W
// module chunks = 24